





































































































import Vue from 'vue'
import Component from 'vue-class-component'
import User from '@/provider/user'
import CircularLoading from '@/components/Loading/CircularLoading.vue'

@Component({
  components: {
    CircularLoading
  }
})
export default class ATWorksheet extends Vue {
  loading: boolean = true
  userId: string = ''
  userProvider!: User
  worksheetData: Array<any> = []

  startDate = new Date()

  shortWeekStrings = [
    'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'
  ]

  async beforeMount () {
    this.userId = this.$route.params.userId
    this.userProvider = new User(this.userId)
    this.setToday()
  }

  get hasSheetData () {
    return this.loading ? false : this.worksheetData.length > 0
  }

  getFormatedDate (dayOfWeek: number) {
    const date = new Date(this.startDate.getTime())
    date.setDate(date.getDate() + dayOfWeek)
    return `${date.getMonth() + 1}/${date.getDate()}(${this.shortWeekStrings[dayOfWeek]})`
  }

  /**
   * 今日を含む週を表示
   */
  setToday () {
    const date = new Date()
    const week = date.getDay()

    date.setDate(date.getDate() - date.getDay())
    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    date.setMilliseconds(0)
    this.startDate = date

    this.loadData()
  }

  /**
   * 前の週を表示
   */
  prevWeek () {
    this.startDate.setDate(this.startDate.getDate() - 7)
    this.loadData()
  }

  /**
   * 次の週を表示
   */
  nextWeek () {
    this.startDate.setDate(this.startDate.getDate() + 7)
    this.loadData()
  }

  /**
   * 指定した曜日のデータを取得
   */
  loadData () {
    this.loading = true
    this.userProvider.getWorksheetWithDate('BI', 'startDate', this.startDate).then((result) => {
      this.worksheetData = result
      this.loading = false
      console.log('ワークシートデータ')
      console.log(result)
    })
  }

  /*
   * 回数項目のフォーマット
   */
  formatTimes (times: number) {
    if (isNaN(times)) {
      return ''
    }
    return `${times}回`
  }

  /**
   * 分数をh時間m分形式にフォーマット
   */
  formatMinutes (minutes: number) {
    let negativeValue = minutes < 0
    let hour = Math.floor(Math.abs(minutes) / 60)
    let min = Math.abs(minutes) % 60

    if (isNaN(min)) {
      return ''
    }

    if (hour > 0) {
      return (negativeValue ? '-' : '') + `${hour}時間${min}分`
    } else {
      return (negativeValue ? '-' : '') + `${min}分`
    }
  }

  /**
   * 分数をhh:mm形式にフォーマット
   */
  minutesToTime (minutes: number) {
    const negativeValue = minutes < 0
    if (negativeValue) {
      minutes = 60 * 24 + minutes
    }
    let hour = Math.floor(minutes / 60)
    let min = Math.abs(minutes) % 60

    if (isNaN(min)) {
      return ''
    }

    return `${('00' + hour).slice(-2)}:${('00' + min).slice(-2)}`
  }

  /**
   * 睡眠効率計算
   */
  calcSleepEfficiency (timeToGetIntoBed: number, timeToGetOutOfBed: number, preSleepTime: number, snoozeTime: number, awakeningTime: number) {
    const timeSpentInBed = this.calcTimeSpentInBed(timeToGetIntoBed, timeToGetOutOfBed)
    const sleepingTime = this.calcSleepingTime(timeToGetIntoBed, timeToGetOutOfBed, preSleepTime, snoozeTime, awakeningTime)
    if (isNaN(sleepingTime)) {
      return ''
    }
    return `${Math.round((sleepingTime / timeSpentInBed) * 100)}%`
  }

  /**
   * 寝床にいた時間計算
   */
  calcTimeSpentInBed (timeToGetIntoBed: number, timeToGetOutOfBet: number) {
    return timeToGetOutOfBet - timeToGetIntoBed
  }

  /**
   * 睡眠時間計算
   */
  calcSleepingTime (timeToGetIntoBed: number, timeToGetOutOfBed: number, preSleepTime: number, snoozeTime: number, awakeningTime: number) {
    const timeSpentInBed = this.calcTimeSpentInBed(timeToGetIntoBed, timeToGetOutOfBed)
    return timeSpentInBed - preSleepTime - snoozeTime - awakeningTime
  }
}
